var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenEyes = function SvgOpenEyes(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eyes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u51FA\\u5165\\u91D1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ACH-\\u5165\\u91D1\\u663E\\u793A\\u4F59\\u989D",
    transform: "translate(-600.000000, -541.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eyes",
    transform: "translate(600.000000, 541.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.166667, 2.722222)",
    stroke: "#62657A",
    strokeWidth: 1.16666667
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333333,8.68518519 C9.55262771,8.68518519 11.6666667,5.53360767 11.6666667,4.34259259 C11.6666667,3.15157751 9.55262771,0 5.83333333,0 C2.11403895,0 0,3.15157751 0,4.34259259 C0,5.53360767 2.11403895,8.68518519 5.83333333,8.68518519 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.194383,2.76433867 C6.07851554,2.73679986 5.95762683,2.72222222 5.83333333,2.72222222 C4.97422372,2.72222222 4.27777778,3.41866817 4.27777778,4.27777778 C4.27777778,5.13688739 4.97422372,5.83333333 5.83333333,5.83333333 C6.69244294,5.83333333 7.38888889,5.13688739 7.38888889,4.27777778 C7.38888889,4.17929408 7.37973683,4.08294797 7.36223681,3.98954353",
    id: "Oval",
    strokeLinecap: "round"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenEyes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/open-eyes.3d251827.svg";